import _ from 'lodash';

export default function redactAttachment(attachments, id) {
  const attachment = _.find(attachments, { id });
  attachment && attachment.redact();
}
